function turnOnPreloader(global, selector) {
	var div = document.createElement('div');
	div.setAttribute("id", "preloaderblock");
	div.style.backgroundColor = "#f0f0fc";
	div.style.opacity = "0.5";
	div.style.backgroundRepeat = "no-repeat";
	div.style.backgroundPosition = "center";
	div.style.top = "0";
	div.style.left = "0";
	div.style.right = "0";
	div.style.bottom = "0";
	div.style.zIndex = "1100";
	div.style.backgroundImage = "url('./img/preloader.gif')";
	if (global === true) {
		div.style.position = "fixed";
		document.getElementById('body').appendChild(div);
	} else if (typeof selector == "string") {
		div.style.position = "absolute";
		//div.style.position = "relative";
		container = document.querySelector(selector);
		container.style.position = "relative";
		container.appendChild(div);
	} else if (typeof selector == "object") {
		div.style.position = "absolute";
		//div.style.position = "relative";
		selector.style.position = "relative";
		selector.appendChild(div);
	}
}
function turnOffPreloader() {
	if (document.getElementById('preloaderblock')) {
		//обновляем список елементов в желаниеях если на странице товара
		if (document.getElementById('wh_ajx_result')) {
			//alert('wh_ajx_result');
			getPopupWishList();
		}
		document.getElementById('preloaderblock').remove();
	}
}
module.exports = {
	start: turnOnPreloader,
	stop: turnOffPreloader
}



// WEBPACK FOOTER //
// ./libs/preloader/preloader.js